var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#0516C8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_2629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9994 35.7147C33.1554 35.7147 35.7137 33.1563 35.7137 30.0004C35.7137 26.8445 33.1554 24.2861 29.9994 24.2861C26.8435 24.2861 24.2852 26.8445 24.2852 30.0004C24.2852 33.1563 26.8435 35.7147 29.9994 35.7147Z",
    stroke: "#0516C8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.82 20.9998C22.96 24.1198 20.6 27.3398 20.6 32.7198C20.92 32.6198 21.2 32.6198 21.48 32.6198C24.02 32.6198 26.48 34.3398 26.48 37.4398C26.48 40.6598 24.42 42.6598 21.48 42.6598C17.68 42.6598 15.5 39.6198 15.5 34.1598C15.5 26.5598 19 21.0998 25.54 17.3198L27.82 20.9998ZM41.82 20.9998C36.96 24.1198 34.6 27.3398 34.6 32.7198C34.92 32.6198 35.2 32.6198 35.48 32.6198C38.02 32.6198 40.48 34.3398 40.48 37.4398C40.48 40.6598 38.42 42.6598 35.48 42.6598C31.7 42.6598 29.52 39.6198 29.52 34.1598C29.52 26.5598 33.02 21.0998 39.56 17.3198L41.84 20.9998H41.82Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_2629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/quoteIcon.2771fba9ee791e1afd478b096b30b42b.svg";
export { ForwardRef as ReactComponent };